export interface StoreMetadata {
  phone?: string;
  contactEmail?: string;
  notes?: string;
}

export const storeOperatingModelValues = ['mono_station', 'multi_station'] as const;
export type StoreOperatingModel = (typeof storeOperatingModelValues)[number];

export interface StoreDto extends StoreMetadata {
  id: string; // UUID
  companyId: string; // tenant FK
  name: string;
  code?: string; // optional internal identifier
  timezone?: string;
  mainLocationId?: string; // FK to locations.id within the same company
  operatingModel: StoreOperatingModel;
  primaryStationId?: string; // required for multi-station once configured
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
}

export interface CreateStoreRequest extends StoreMetadata {
  companyId: string;
  name: string;
  code?: string;
  timezone?: string;
  mainLocationId?: string;
  operatingModel?: StoreOperatingModel;
  primaryStationId?: string;
}

export interface CreateStoreResponse {
  store: StoreDto;
}

export interface UpdateStoreRequest extends StoreMetadata {
  companyId: string;
  storeId: string;
  name?: string;
  code?: string;
  timezone?: string | null;
  mainLocationId?: string;
  operatingModel?: StoreOperatingModel;
  primaryStationId?: string | null;
}

export interface UpdateStoreResponse {
  store: StoreDto;
}

export interface GetStoreRequest {
  companyId: string;
  storeId: string;
}

export interface GetStoreResponse {
  store: StoreDto;
}

export interface ListStoresByCompanyRequest {
  companyId: string;
  page?: number;
  pageSize?: number;
}

export interface ListStoresByCompanyResponse {
  items: StoreDto[];
  page: number;
  pageSize: number;
  total: number;
}
